module.exports = __webpack_public_path__ + "static/BDI-logo-a65cd248757a72273b281e85d2424332.svg";